module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei7.svg";